import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=0e96d494&"
import script from "./EventCalendar.vue?vue&type=script&lang=js&"
export * from "./EventCalendar.vue?vue&type=script&lang=js&"
import style0 from "./EventCalendar.vue?vue&type=style&index=0&id=0e96d494&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports